import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var UserCheck = createReactComponent("UserCheck", ["svg", defaultAttributes, [["path", {
  d: "M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2",
  key: "1octem"
}], ["circle", {
  cx: "8.5",
  cy: "7",
  r: "4",
  key: "195wvc"
}], ["polyline", {
  points: "17 11 19 13 23 9",
  key: "1x6o07"
}]]]);
export default UserCheck;